import Table from './table.vue';
export default Table;


// WEBPACK FOOTER //
// ./src/components/table/index.js